import type { Translate } from '@shared/hooks/locale';

/**
 * Signals of the dbt engagement score, in display order. Keys match the
 * `organisation_engagement_score` action's `signals[].key` and the per-signal
 * fields of its `history[]` points.
 */
export const ENGAGEMENT_SIGNALS = [
  {
    key: 'profile',
    label: (t: Translate) => t('Completion'),
    color: '#546e7a',
  },
  { key: 'reviews', label: (t: Translate) => t('Reviews'), color: '#2e7d32' },
  {
    key: 'transactions',
    label: (t: Translate) => t('Transactions'),
    color: '#5e35b1',
  },
  {
    key: 'visibility',
    label: (t: Translate) => t('Visibility'),
    color: '#00897b',
  },
  { key: 'cma', label: (t: Translate) => t('CMA'), color: '#1976d2' },
  {
    key: 'prospection_map',
    label: (t: Translate) => t('Prospection map'),
    color: '#7b1fa2',
  },
  { key: 'crm', label: (t: Translate) => t('CRM'), color: '#ed6c02' },
  { key: 'widget', label: (t: Translate) => t('Widget'), color: '#c2185b' },
] as const;
